import {
  FALLBACK_JOB_STATUSES,
  JOB_STATUS_LABELS,
  type JobOpportunity,
} from '../state/jobOpportunities'

export interface JobStatusMenuOption {
  value: string
  label: string
}

export interface JobStatusMenu {
  enabled: boolean
  options: JobStatusMenuOption[]
}

const option = (value: string): JobStatusMenuOption => ({ value, label: JOB_STATUS_LABELS[value] })

const CLOSED: JobStatusMenu = { enabled: false, options: [] }

/**
 * What the Job Detail header status badge offers (MWA-405).
 *  - A job with a status: every current status. The retired 'applying' is not
 *    among them.
 *  - A job awaiting the client's decision (no status, not archived): only
 *    Applied, which Edit also gates behind the "Move to Applied?" confirmation.
 *  - Anything else is not a menu: a hidden opportunity, a job the client
 *    declined (no status, archived), or a viewer who cannot Edit.
 */
export function jobStatusMenu(
  job: Pick<JobOpportunity, 'status' | 'hiddenOpportunity' | 'archived'>,
  canEdit: boolean
): JobStatusMenu {
  if (!canEdit || job.hiddenOpportunity === true) return CLOSED
  if (job.status && job.status !== 'applying') {
    return { enabled: true, options: FALLBACK_JOB_STATUSES.map(option) }
  }
  if (job.archived === true) return CLOSED
  return { enabled: true, options: [option('applied')] }
}
